import angular from 'angular'
import template from './template.html'

const approvalProcessModule = angular
    .module('app.approvalProcess', [])

approvalProcessModule.directive('approvalProcess', ['httpRequest', (httpRequest) => ({
    scope: {
        title: '@',
        param: '<',
    },
    template,
    link(scope) {
        if (!scope.dictData) {
            httpRequest.get_dictByTypeArr(['approve_type', 'wf_approval_state']).then((res) => {
                scope.dictData = res.data.value
            })
        }
        if (!scope.dataList) {
            httpRequest.get_getWorkFlowTracks(scope.param).then((res) => {
                scope.dataList = res.data.value
            })
        }
    },
})])
export default approvalProcessModule.name



// WEBPACK FOOTER //
// ./src/components/approvalProcess/index.js